export default "__VITE_ASSET__BCbmd4ls__"